export default "__VITE_PUBLIC_ASSET__9ba6b855__"